import { StyleSheet } from 'lib/paypalphrodite'
import * as media from '../../lib/styles/media-queries'
import { v2illustrationblack, v2green400 } from '@paypalcorp/pp-react'
import { isDw2Repaint } from 'experiments/dw2Repaint'

const VXLightGrey = '#CBD2D6'
const VXBorderOverride = '#9DA3A6'

export default StyleSheet.create({
  fundingOptionWrapper: {
    padding: '0 3px',
    overflow: 'hidden',
  },
  radioButton: {
    ':before': {
      border: `1px solid ${VXBorderOverride}`,
    },
    marginBottom: -1,
  },
  disabledLabel: {
    cursor: 'not-allowed',
  },
  radioButtonText: {
    display: 'inline-block',
    width: 290, // 310, 210, 130
    margin: '0 0 10px 60px',
  },
  radioButtonTextRTL: {
    display: 'inline-block',
    width: 290, // 310, 210, 130
    margin: '0 60px 10px 0px',
  },
  radioButtonSubText: {
    display: 'block',
    fontSize: 11,
  },
  fundingOptionLogo: {
    position: isDw2Repaint() ? 'relative' : 'absolute',
    top: '0',
    margin: isDw2Repaint() ? 0 : '1px 10px 0 0',
  },
  feeLine: {
    margin: '0 0 10px 105px',
  },
  preferredCheckboxWrapper: {
    paddingLeft: 60, // using padding for this is important for preventIncorrectLabelWrap
    margin: '15px 0 0 0',
    clear: 'both',
  },
  preferredCheckbox: {
    ':before': {
      border: `1px solid ${VXBorderOverride}`,
    },
  },
  firstTimeInfoWrapper: {
    margin: '15px 0 0',
  },
  preferredInfoLink: {
    display: 'block',
    margin: '-12px 0 0 43px',
    cursor: 'pointer',
  },
  fundingOptionContentWrapper: {
    float: 'left',
  },
  preferredBadge: {
    marginLeft: 103,
    padding: '1px 8px',
    background: '#eaf7e9',
    display: 'inline-block',
  },
  preferredBadgeText: {
    fontSize: 11,
    margin: 0,
  },
  lineSeparator: {
    border: 'none',
    ...(!isDw2Repaint() && {
      borderTop: `1px dotted ${VXLightGrey}`,
      color: '#fff',
      height: 1,
      width: '100%',
    }),
  },
  greyedOut: {
    opacity: '.3',
  },
  forceDisplayBlock: {
    display: 'block',
  },
  preventIncorrectLabelWrap: {
    // because the design is specific that the text of the label not wrap beneath checkbox
    display: 'inline-block',
    width: 'calc(100% - 45px)', // the full width, minus the size of checkboxes and radio buttons in VX
  },
  preventIncorrectLabelWrapWithLogo: {
    // because the design is specific that the text of the label not wrap beneath checkbox
    display: 'inline-block',
    width: 'calc(100% - 104px)', // the full width, minus the size of checkboxes and radio buttons in VX
  },
  checkboxOutline: {
    ':before': {
      outlineWidth: '0px',
    },
  },
  choiceCardArt: {
    position: isDw2Repaint() ? 'relative' : 'absolute',
    top: '0',
    borderRadius: 3,
    margin: isDw2Repaint() ? '0 5px' : '0 0 0 5px',
    maxWidth: 40,
    boxShadow: '0px 1px 5px rgba(78, 70, 70, 0.47)',
  },
  fundingSecondaryText: {
    margin: '-8px 0px 3px 0px',
    float: 'right',
    lineHeight: 1,
  },
  ppcreditSpecialOfferText: {
    marginRight: '2px',
    color: '#6c7378',
    [media.smallAndSmaller]: {
      lineHeight: 1.6,
    },
  },
  offerEligibilityText: {
    color: v2illustrationblack,
    fontSize: 14,
  },
  disallowedReasonText: {
    margin: '0 0 0 8.5em',
    padding: '0.25em ',
    fontWeight: 'bold',
    fontSize: '0.8em',
  },
  feeWaived: {
    color: v2green400,
  },
})
